import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/img/oto-academy/logo-academy-modal.png';
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("img", { src: _imports_0 }, null, -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("strong", { class: "oto-academy__modal__title" }, "Entrando no Oto Academy", -1);
const _hoisted_3 = { class: "oto-academy__modal__text" };
const _hoisted_4 = { "data-cy": "oto-academy-modal-created-email" };
const _hoisted_5 = { class: "oto-academy__modal__text" };
const _hoisted_6 = { class: "dialog dialog-buttons" };
import { useMixpanelClickAccess } from '@/utilities/mixpanel/landingPageOtoAcademy';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalCreatedUser',
    props: {
        isVisible: { type: Boolean },
        email: {}
    },
    emits: ['hide'],
    setup(__props, { emit }) {
        const props = __props;
        const hide = () => {
            emit('hide', 'createdUser');
        };
        return (_ctx, _cache) => {
            const _component_btn = _resolveComponent("btn");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: props.isVisible,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((props.isVisible) = $event)),
                "show-close": false,
                "close-on-press-escape": false,
                "close-on-click-modal": false,
                width: "400",
                center: "",
                class: "oto-academy__modal"
            }, {
                default: _withCtx(() => [
                    _hoisted_1,
                    _hoisted_2,
                    _createElementVNode("p", _hoisted_3, [
                        _createTextVNode(" Lembre-se, suas informações de login já foram enviadas para o e-mail "),
                        _createElementVNode("b", _hoisted_4, _toDisplayString(props.email), 1),
                        _createTextVNode(" anteriormente. Verifique a sua caixa de entrada. ")
                    ]),
                    _createElementVNode("p", _hoisted_5, [
                        _createTextVNode(" Esqueceu sua senha? "),
                        _createElementVNode("a", {
                            href: "https://academy.otocrm.com.br/users/password/new",
                            target: "_blank",
                            "data-cy": "oto-academy-modal-created-btn-password",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(useMixpanelClickAccess)('view_oto-academy_click_reset-password', 'ModalCreatedUser')))
                        }, "Clique aqui para recuperar")
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_btn, {
                            class: "btn btn-outline-ctx-primary",
                            onClick: hide
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode("Fechar")
                            ]),
                            _: 1
                        }),
                        _createElementVNode("a", {
                            class: "btn",
                            href: "https://academy.otocrm.com.br/",
                            target: "_blank",
                            "data-cy": "oto-academy-modal-created-btn-access",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_unref(useMixpanelClickAccess)('view_oto-academy_click_access-now', 'ModalCreatedUser')))
                        }, "Acessar agora")
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
